import { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

// Imagem servida por presigned URL do S3 (FEAT-011). A URL tem validade
// (S3_EXPIRES_IN): se a galeria ficar aberta por mais tempo que o TTL, o S3
// passa a responder 403 e a imagem "quebra". Este componente se auto-recupera:
// no onError, pede uma URL nova (refreshUrl) e recarrega — sem F5 do usuário.
const S3Image = ({ src, refreshUrl, alt, ...rest }) => {
  const [currentSrc, setCurrentSrc] = useState(src);

  // Limita re-tentativas para não entrar em loop se o erro não for expiração
  // (ex.: arquivo removido do bucket, sem rede).
  const retries = useRef(0);

  useEffect(() => {
    setCurrentSrc(src);
    retries.current = 0;
  }, [src]);

  const handleError = async () => {
    if (!refreshUrl || retries.current >= 2) return;

    retries.current += 1;

    const fresh = await refreshUrl();

    // Os services resolvem com a URL (string) no sucesso ou um objeto de erro.
    if (typeof fresh === 'string' && fresh) setCurrentSrc(fresh);
  };

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img src={currentSrc} alt={alt} onError={handleError} {...rest} />;
};

S3Image.propTypes = {
  src: PropTypes.string,
  refreshUrl: PropTypes.func,
  alt: PropTypes.string,
};

S3Image.defaultProps = {
  src: undefined,
  refreshUrl: null,
  alt: '',
};

export default S3Image;
